import React from 'react';

export const Setting2 = props =>{
    return(
        <div>
            <p>This is another setting</p>
        </div>
    )
}